<script>
const periodTypeOption = [
  {
    title: '日',
    type: 'day',
  },
  {
    title: '月',
    type: 'month',
  },
  {
    title: '年',
    type: 'year',
  },
]

export default {
  components: {
    // ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isAuto: 0,
      periodTypeOption: [...periodTypeOption],
      upgradeCondition: {
        list: [{ type: 'deposit', text: '儲值' }, { type: 'order', text: '消費金額' }],
        options: {
          deposit: [{ type: 'deposit-single', text: '單次儲值金額' }, { type: 'deposit-total', text: '累計儲值金額' }, { type: 'deposit-plan', text: '購買儲值方案' }],
          order: [{ type: 'order-single', text: '單次消費金額' }, { type: 'order-total', text: '累計消費金額' }],
        },
      },
      currentCondition: [
        {
          logic: 'OR',
          type: '',
          condition: '',
          value: '',
        },
      ],
      depositList: [],
    }
  },
  computed: {
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入等級方案名稱',
          },
        ],
        period: [
          {
            required: true,
            message: '請輸入天數',
          },
        ],
        // description: [
        //   {
        //     required:true,
        //     message:'請輸入內容'
        //   }
        // ],
        discount: {
          prepaid: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          cosmetic: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          deposit: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          daycare: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          homestay: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
        },
      }
    },
    // currentCategory(){
    //   return this.category.filter(item=>{
    //     return item.children.length > 0
    //   })
    // },
    isEditMode() {
      // console.log(this.defaultValue)
      return !!this.defaultValue.id
    },
    productBaseBookingUrl() {
      // return `${this.merchantUrl}/booking/${this.currentProductAlias}/`
      let url = ''
      if (window.globalData.APP_ENV === 'local') {
        url = this.merchantUrl
      } else {
        const prefixUrl = this.merchantUrl.split('//', 2)
        url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
        // url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}/reservation/`
      }
      return url
    },
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
    addButtonHandle() {
      const result = this.currentCondition.every((condition) => condition.type && condition.condition && condition.value)

      if (this.isAuto) this.$emit('saveStatus', result)

      return result
    },
    isConditionChange() {
      const conditions = this.submitData.upgradeCondition

      if (this.currentCondition.length !== conditions.length) return true

      const isChanged = conditions.some((condition, index) => {
        return condition.value !== this.currentCondition[index].value || condition.type !== this.currentCondition[index].condition
      })

      return isChanged
    },
  },
  watch: {
    'submitData.upgradeCondition': {
      handler(nvl) {
        if (nvl.length) {
          const switchOpen = nvl.every((condition) => condition.value)
          if (switchOpen) this.isAuto = 1

          const conditions = nvl.map((item) => {
            const type = item.type.split('-')[0]
            const condition = item.type

            return {
              logic: item.logic,
              type: type,
              condition: condition,
              value: item.value,
            }
          })
          this.currentCondition = conditions
        }
      },
      deep: true,
      immediate: true,
    },
    currentCondition: {
      handler(nvl) {
        if (this.isConditionChange) this.$emit('updateCondition', nvl)
      },
      deep: true,
    },
    isAuto: {
      handler(nvl) {
        if (!nvl) {
          this.currentCondition = [
            {
              logic: 'OR',
              type: '',
              condition: '',
              value: '',
            },
          ]

          this.$emit('saveStatus', true)
        }
      },
      immediate: true,
    },
  },
  created() {
    // if(!this.isEditMode){
    //   this.submitData.startDate = formatDate(new Date(),'date-dash')
    // }
  },
  async mounted() {
    this.tryToGetDeposit()
  },
  methods: {
    addCondition() {
      this.currentCondition.push({
        logic: 'OR',
        type: '',
        condition: '',
        value: '',
      })
    },
    deleteCondition(index) {
      this.currentCondition.splice(index, 1)
    },
    async tryToGetDeposit() {
      const { items } = await this.$store.dispatch('deposit/fetchListAll', { paginate: 0 })
      this.depositList = items.filter((item) => item.state === 1)
    },
    test() {
      console.log(this.isAuto)
    },
  },
}
</script>

<template>
  <div class="isStylePageContent">
    <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top" :class="$style.form" autocomplete="off">
      <h4 class="form-block-title mb-4">基本設定</h4>
      <el-row>
        <el-col :span="24">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span>是否上架方案？</span>
            <el-switch v-model="submitData.state" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="d-flex justify-content-between align-items-center">
            <span>是否為自動方案？</span>
            <el-switch v-model="isAuto" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
          </div>
        </el-col>
      </el-row>
      <div v-if="isAuto === 1">
        <h4 class="form-block-title mb-4 d-inline-block mr-3">自動條件</h4>
        <span>自動方案可設定不同條件組合（例如：消費總金額 ＋ 消費次數）</span>
        <el-form v-for="(condition, index) in currentCondition" :key="index" class="upgradeCondition mb-4" label-position="right" label-width="auto">
          <el-form-item :label="'條件 ' + Math.abs(Number(index) + 1)" required>
            <el-select v-model="condition.type" placeholder="請選擇">
              <el-option v-for="(opt, i) in upgradeCondition.list" :key="i" :label="opt.text" :value="opt.type"></el-option>
            </el-select>
          </el-form-item>
          <div class="d-flex justify-content-between align-items-center">
            <span v-if="condition.type">條件選項</span>
            <div v-if="condition.type && currentCondition.length > 1">
              <a href="#" @click="deleteCondition(index)">
                <i class="el-icon-close fs-2"></i>
              </a>
            </div>
            <div v-if="!condition.type && currentCondition.length > 1" class="w-100 d-flex justify-content-end">
              <a href="#" @click="deleteCondition(index)">
                <i class="el-icon-close fs-2"></i>
              </a>
            </div>
          </div>
          <div v-if="condition.type">
            <el-form-item>
              <el-radio-group v-model="condition.condition" @change="condition.value = ''">
                <el-radio v-for="(opt, i) in upgradeCondition.options[condition.type]" :key="i" :label="opt.type">{{ opt.text }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-select v-if="condition.condition === 'deposit-plan'" v-model="condition.value" :disabled="condition.condition === ''" placeholder="請選擇方案">
                <el-option v-for="deposit in depositList" :key="deposit.uuid" :label="deposit.title" :value="deposit.uuid"></el-option>
              </el-select>
              <el-input v-else v-model="condition.value" type="number" :disabled="condition.condition === ''" placeholder="請輸入金額">
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
        <el-button type="info" plain class="is-round border-0 w-100 text-dark" :disabled="!addButtonHandle" @click="addCondition">
          <BaseIcon name="plus" />
          新增條件
        </el-button>
      </div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="名稱" prop="title" required>
            <el-input v-model="submitData.title" class="is-border bg-white" />
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="24">
          <el-form-item label="效期(輸入0表示沒有期限)" prop="period" required>
            <el-input v-model.number="submitData.period" min="0" :disabled="!!defaultValue.default" class="is-border bg-white isStyleSelect">
              <el-select slot="append" v-model="submitData.periodType" :disabled="!!defaultValue.default" class="is-border is-round">
                <el-option v-for="item in periodTypeOption" :key="item.type" :value="item.type" :label="item.title"> </el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="權益說明" prop="description">
            <el-input v-model="submitData.description" type="textarea" class="is-border bg-white is-round" :autosize="{ minRows: 7 }" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }
    .el-input-group__append {
      background-color: $color-line;
      border-radius: 0 5px 5px 0;
    }
    .el-input {
      &.isStyleText {
        .el-input-group__append {
          background: transparent;
          border-radius: 0;
          border-left: 0;
        }
        .el-input__inner {
          border-radius: 5px;
        }
      }
    }
  }
}
// %img-size {
//   width: calc(33.333333% - 10px);
//   height: 175px;
//   @include max-sm {
//     width: calc(100% - 10px);
//   }
// }
:global {
  .el-input {
    background-color: transparent !important;
  }
  .upgradeCondition {
    background: #eee;
    padding: 20px 15px;

    a,
    a:visited {
      color: #909399;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      -o-appearance: none !important;
      -ms-appearance: none !important;
      appearance: none !important;
      margin: 0;
    }
    input[type='number'] {
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      -o-appearance: textfield;
      -ms-appearance: textfield;
      appearance: textfield;
    }
  }
  //   :local(.upload) {
  //     margin: 0 -10px;
  //     border-top: none !important;
  //     > div {
  //       @extend %img-size;
  //     }

  //     .image-and-action {
  //       @extend %img-size;
  //       & + div {
  //         @extend %img-size;
  //       }
  //     }
  //   }
  // }
  // .form-item--split {
  //   display: flex;
  //   align-items: center;
  //   height: 40px;
  //   line-height: 40px;

  //   :global {
  //     .el-radio-group {
  //       flex-shrink: 0;
  //       margin-right: 15px;
  //     }
  //     .el-input {
  //       max-width: 150px;
  //     }
  //   }
  // }
}
</style>
